//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import eventBus from './eventBus.js'

export default {
  name: 'TOtherPage',

  components: {},

  data () {
    return { }
  },

  // beforeRouteEnter (from, old, next) {
  //   console.log(from, old)
  //   next()
  // },
  watch: {
    $route (val) {
      // if (this.$attrs.level && !this.currentComponentData && val === 'TOtherPage') {
      this.handlerRefreshPage()

      // }
    },
  },

  computed: {
    ...mapGetters('cache', [
      'aliveComponentsData',
      'aliveComponents',
    ]),
    currentComponentData () {
      // console.log('currentComponentData', this.$attrs.level, this.currentComponentData)
      const { level } = this.$attrs

      return this.aliveComponentsData[`t-other-page-${level}`]
    },

    cSelectGoRouterFlag () {
      return this.currentComponentData?.cSelectGoRouter || false
    },

    eventListeners () {
      const listeners = this.currentComponentData?.listeners

      return {
        'on-return': this.returnPrePage,
        ...listeners,
      } || {}
    },
  },

  created () {
    this.handlerRefreshPage()
  },

  methods: {
    handlerRefreshPage () {
      if (!this.cSelectGoRouterFlag && this.$attrs.level && !this.currentComponentData && this.$route.name === 'TOtherPage') {
        this.returnPrePage()
      }
    },

    returnPrePage (...args) {
      this.$router.go(-1)

      eventBus.$emit(`return-cache-page${this.$attrs.cacheUid}`, {
        ...args,
        cacheUid: this.$attrs.cacheUid,
      })
    },
  },
}
